import { createSlice, PayloadAction } from "@reduxjs/toolkit/react"

type ApiRequestsState = {
	requestCounts: Record<string, number>
	requestErrors: Record<string, unknown>
}

const initial: ApiRequestsState = {
	requestCounts: {},
	requestErrors: {}
}

export const apiRequestsSlice = createSlice({
	name: "apiRequests",
	initialState: initial,
	reducers: {
		startRequest: (state, { payload: key }: PayloadAction<string>) => {
			const current = state.requestCounts[key] ?? 0
			state.requestCounts[key] = current + 1
		},
		trackError: (
			state,
			{
				payload: { key, error }
			}: PayloadAction<{ key: string; error: unknown }>
		) => {
			state.requestErrors[key] = error
		},
		clearError: (state, action: PayloadAction<string>) => {
			delete state.requestErrors[action.payload]
		},
		finishRequest: (state, action: PayloadAction<string>) => {
			const current = state.requestCounts[action.payload] ?? 0
			if (current <= 1) {
				delete state.requestCounts[action.payload]
			} else {
				state.requestCounts[action.payload] = current - 1
			}
		}
	}
})

export default apiRequestsSlice.reducer
